export const NOTIFICATIONS = {
  title: 'Benachrichtigungen',
  markAllAsRead: 'Alle als gelesen markieren',
  markAsRead: 'Als gelesen markieren',
  markAsUnread: 'Als ungelesen markieren',
  delete: 'Benachrichtigung löschen',
  ariaLabel: 'Benachrichtigungen anzeigen',
  viewDetails: 'Details ansehen',
  empty: {
    title: 'Noch keine Benachrichtigungen',
    description: 'Hier erscheinen neue Ereignisse zu deinen Projekten.',
  },
} as const
